import React from "react";
import LogoDark from "../assets/acebit-logo-white.svg";

import DesktopTopbar from "./topbardesktop"
import ColorToggle from "./colortoggle";
import Hamburger from "./Hamburger";
import NavLink from "./navlink";
import { NAV_ITEMS } from "../constants/site";

const Topbar = () => {
  return (
    <header className="sticky top-0 z-20 h-16 border-b border-white/10 bg-slate-950/70 text-white backdrop-blur-md">
      <div className="container-page flex h-full items-center justify-between">
        <NavLink target="home">
          <img src={LogoDark} alt="Acebit" width={104} />
        </NavLink>
        <div className="flex items-center gap-2 sm:gap-4">
          <DesktopTopbar links={NAV_ITEMS} />
          <ColorToggle />
          <Hamburger links={NAV_ITEMS} />
        </div>
      </div>
    </header>
  );
};

export default Topbar;
